(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["norvela-actie"] && !Shopify.designMode) return;
  try {
    (() => {
  // Leest de prijs uit het prijsblok in dezelfde koopkolom, zodat het
  // bespaarbedrag automatisch meeloopt met de gekozen variant. Er wordt niets
  // hardgecodeerd: staat er geen vanafprijs, dan blijft de regel verborgen.
  const naarGetal = (tekst) => {
    if (!tekst) return null;
    // "€1.234,56" -> 1234.56 · punten zijn duizendtallen, komma is decimaal
    const schoon = tekst.replace(/[^\d.,]/g, '').replace(/\./g, '').replace(',', '.');
    const getal = parseFloat(schoon);
    return Number.isFinite(getal) ? getal : null;
  };

  const alsGeld = (getal) =>
    '€' + getal.toFixed(2).replace('.', ',');

  const ververs = (blok) => {
    const kolom = blok.closest('.product-details, [class*="product-details"]') || document;
    const prijsblok = kolom.querySelector('product-price') || document.querySelector('product-price');
    const regel = blok.querySelector('[data-nv-actie-bespaar]');
    if (!prijsblok || !regel) return;

    const nu = naarGetal(prijsblok.querySelector('.price')?.textContent);
    const was = naarGetal(prijsblok.querySelector('.compare-at-price')?.textContent);

    if (nu === null || was === null || was <= nu) {
      regel.hidden = true;
      return;
    }
    const verschil = was - nu;
    blok.querySelector('[data-nv-actie-bedrag]').textContent = alsGeld(verschil);
    blok.querySelector('[data-nv-actie-procent]').textContent =
      '(' + Math.round((verschil / was) * 100) + '% korting)';
    regel.hidden = false;
  };

  const start = () => {
    document.querySelectorAll('[data-nv-actie]').forEach((blok) => {
      ververs(blok);
      const prijsblok =
        (blok.closest('.product-details, [class*="product-details"]') || document)
          .querySelector('product-price');
      if (!prijsblok) return;
      // Horizon vervangt de inhoud van <product-price> bij een variantwissel.
      new MutationObserver(() => ververs(blok)).observe(prijsblok, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  // Na het opnieuw renderen van een sectie in de theme-editor.
  document.addEventListener('shopify:section:load', start);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["norvela-bewijs"] && !Shopify.designMode) return;
  try {
    (() => {
  const spelers = document.querySelectorAll('[data-nv-bw-video]');
  if (!spelers.length) return;

  // Pas laden en afspelen als de video in beeld komt, en weer pauzeren zodra
  // hij eruit is. Drie video's die meteen starten kost te veel op mobiel.
  const kijker = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const video = entry.target;
      if (entry.isIntersecting) {
        if (video.preload === 'none') {
          video.preload = 'auto';
          video.load();
        }
        const poging = video.play();
        if (poging) poging.catch(() => {});
      } else {
        video.pause();
      }
    });
  }, { rootMargin: '150px 0px', threshold: 0.25 });

  spelers.forEach((video) => kijker.observe(video));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["norvela-keuze"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = (root) => {
    if (root.dataset.nvKlaar === '1') return;
    root.dataset.nvKlaar = '1';

    const kaarten = [...root.querySelectorAll('[data-nv-optie]')];
    if (!kaarten.length) return;

    // De echte radioknoppen van het thema. Die blijven leidend: zij regelen
    // prijs, voorraad en de knop. Onze kaarten zijn er alleen de bediening van.
    const radio = (id) =>
      document.querySelector(`variant-picker input[data-variant-id="${id}"]`);

    const teken = (id) => {
      kaarten.forEach((k) => {
        const aan = k.dataset.nvVariant === String(id);
        k.classList.toggle('is-gekozen', aan);
        k.setAttribute('aria-checked', aan ? 'true' : 'false');
      });
    };

    const kies = (kaart) => {
      const id = kaart.dataset.nvVariant;
      const input = radio(id);
      // Meteen tekenen, niet wachten op het thema: anders voelt de klik traag.
      teken(id);
      if (input && !input.checked) input.click();
    };

    kaarten.forEach((kaart) => {
      kaart.addEventListener('click', () => kies(kaart));
      kaart.addEventListener('keydown', (e) => {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          kies(kaart);
        }
      });
    });

    // Verandert de variant ergens anders — via de terugknop, een deeplink of
    // een andere picker — dan volgen de kaarten. Alleen tekenen, niet klikken,
    // anders sturen de twee elkaar in een kringetje rond.
    document.addEventListener('change', (e) => {
      const input = e.target.closest && e.target.closest('variant-picker input[data-variant-id]');
      if (input && input.checked) teken(input.dataset.variantId);
    });

    if (root.dataset.nvVerberg === 'true') {
      // Niet met display:none: de radioknoppen moeten aanklikbaar blijven voor
      // het thema zelf. Alleen visueel weghalen, uit de tabvolgorde halen.
      document.querySelectorAll('variant-picker .variant-option').forEach((veld) => {
        veld.style.cssText =
          'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip-path:inset(50%);white-space:nowrap;border:0;';
        veld.querySelectorAll('input').forEach((i) => i.setAttribute('tabindex', '-1'));
      });
    }

    const aan = document.querySelector('variant-picker input[data-variant-id]:checked');
    if (aan) teken(aan.dataset.variantId);
  };

  const alles = () => document.querySelectorAll('[data-nv-keuze]').forEach(start);

  document.addEventListener('DOMContentLoaded', alles);
  // De theme-editor bouwt secties opnieuw op zonder de pagina te herladen.
  document.addEventListener('shopify:section:load', alles);
  alles();
})();
  } catch(e) { console.error(e); }
})();

})();
